import React, { useEffect } from "react";
import { useCallback } from "react";
import ReactDOM from "react-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  IOmniumType,
  IPopupManagerProps,
  PopupType,
} from "../../Models/Entities";
import { popupState } from "../../Store/atoms";
import { unBlurRoot } from "../../Utilities/DOMFunctions";
import AddFavoritePopup from "./Popups/AddFavoritePopup";
import AddTypePopup from "./Popups/AddTypePopup";
import ConfirmActionPopup from "./Popups/ConfirmActionPopup";
import DeleteRecordPopup from "./Popups/DeleteRecordPopup";
import DuplicateTablePopup from "./Popups/DuplicateTablePopup";
import EditRecordPopup from "./Popups/EditRecordPopup";
import EditRowPopup, { IChooseAction } from "./Popups/EditRowPopup";
import EditTypePopup from "./Popups/EditTypePopup";
import UploadPopup from "./Popups/UploadPopup";

const element = document.getElementById("portal") as HTMLElement;

export default () => {
  const [popup, setPopup] = useRecoilState(popupState);
  const disablePopup = useCallback(() => {
    setPopup(null);
    unBlurRoot();
  }, []);

  useEffect(() => {
    if (popup !== null) {
      document.getElementById("root")?.addEventListener("click", disablePopup);
    } else {
      document
        .getElementById("root")
        ?.removeEventListener("click", disablePopup);
    }
  }, [popup]);

  if (popup === null) {
    return null;
  }

  switch (popup.type) {
    case PopupType.ChooseAction:
      const editProps = popup.props as IChooseAction;
      return ReactDOM.createPortal(
        <EditRowPopup {...editProps} />,

        element
      );

    case PopupType.DeleteRecord:
      return ReactDOM.createPortal(<DeleteRecordPopup />, element);

    case PopupType.EditRecord:
      return ReactDOM.createPortal(
        <EditRecordPopup type={popup.type} omniumType={null} />,
        element
      );

    case PopupType.AddRecord:
      const addProps = popup.props as IOmniumType | null;
      return ReactDOM.createPortal(
        <EditRecordPopup type={popup.type} omniumType={addProps} />,
        element
      );

    case PopupType.DuplicateRecord:
      return ReactDOM.createPortal(
        <EditRecordPopup type={popup.type} omniumType={null} />,
        element
      );

    case PopupType.AddNewType:
      const addTypeProps = popup.props as any;
      return ReactDOM.createPortal(
        <AddTypePopup type={addTypeProps.type} />,
        element
      );

    case PopupType.AddFavorite:
      return ReactDOM.createPortal(
        <AddFavoritePopup type={popup.type} />,
        element
      );

    case PopupType.CreateTable:
      return ReactDOM.createPortal(
        <AddFavoritePopup type={popup.type} />,
        element
      );

    case PopupType.UploadTable:
      return ReactDOM.createPortal(<UploadPopup />, element);

    case PopupType.DuplicateTable:
      return ReactDOM.createPortal(<DuplicateTablePopup />, element);

    case PopupType.ConfirmAction:
      const confirmProps = popup.props;
      return ReactDOM.createPortal(
        <ConfirmActionPopup message={confirmProps.message} />,
        element
      );

    case PopupType.EditType:
      const editTypeProps = popup.props;
      return ReactDOM.createPortal(
        <EditTypePopup {...editTypeProps} />,
        element
      );

    default:
      return null;
  }
};
